<!-- 
  话费流量充值记录
  lovi 2020-07-29
 -->
<template>
  <div class="recharge">
    <div class="breadcrumb-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("common.eepay") }}</BreadcrumbItem>
        <BreadcrumbItem>{{
          $t("wallet.rechargeWithdrawRecord")
        }}</BreadcrumbItem>
      </Breadcrumb>
      <a class="returnA" v-if="detailFlag" @click="returnFun">
        {{ $t("common.back") }}
      </a>
    </div>
    <!-- 列表 -->
    <div v-show="!detailFlag">
      <search
        :dateFlag="true"
        :typeFlag="true"
        :typeList="typeList"
        :statusFlag="true"
        :statusList="selectList"
        @search="_getSearch"
      />
      <div class="no-data" v-if="!listData.length && getListFlag">
        <img
          :src="
            require('@/assets/images/public/no_data_' +
              (language == 'en' ? 'en' : 'cn') +
              '.png')
          "
        />
        <p>{{ $t("common.noData") }}</p>
      </div>
      <div class="list-wrap" v-if="listData.length && getListFlag">
        <div
          class="item-list"
          v-for="(item, index) in listData"
          :key="index"
          @click="toDetail(item)"
        >
          <div class="item-l">
            <div class="headimg">
              <img
                :src="
                  item.icon
                    ? httpUrl + item.icon
                    : require('@/assets/images/public/logo_icon@2x.png')
                "
              />
            </div>
            <div class="info">
              <h3>{{ item.type_name }}</h3>
              <p>{{ item.createtime }}</p>
            </div>
          </div>
          <div class="item-r">
            <h4>{{ item.money }}</h4>
            <p :class="item.status_key == 1 ? 'text-red' : 'text-blue'">
              {{ item.status }}
            </p>
          </div>
        </div>
        <div class="total-info-list">
          <div class="total">
            <span>{{ $t("common.totalIncome") }}：{{ totalIncome }}P</span>
            <span
              >{{ $t("common.totalExpenditure") }}：{{
                totalExpenditure
              }}P</span
            >
          </div>
          <div class="page-wrapper" v-if="totalPage > 0">
            <Page
              size="small"
              show-total
              :total="totalPage"
              :current.sync="page"
              @on-change="nextPage"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 详情 -->
    <detail
      v-if="detailFlag"
      :detailFlag.sync="detailFlag"
      :order_id="detail.order_id"
      :type="detail.type"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDate } from "@/commonJs";
import Search from "@/components/search";
import Detail from "@/components/detail";
export default {
  name: "wallet-record",
  components: {
    Search,
    Detail
  },
  data() {
    return {
      getListFlag: false,
      startDate: formatDate(new Date()), //开始时间
      endDate: formatDate(new Date()), //结束时间
      type: 0, // 交易类型
      // 交易类型列表
      typeList: [
        { key: "", name: this.$t("common.all") },
        { key: 1, name: this.$t("wallet.balanceRecharge") },
        { key: 200, name: this.$t("withdraw.bankCardWithdraw") },
        { key: 201, name: this.$t("withdraw.aliPayWithdraw") }
      ],
      status: "", //选择类型
      selectList: [],
      page: 1,
      listData: [],
      totalIncome: 0, // 总收入
      totalExpenditure: 0, // 总支出
      totalPage: 0,

      detailFlag: false, // 详情页Flag
      detail: {}
    };
  },
  created() {
    this.getStatusList();
  },
  mounted() {},
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    getStatusList() {
      // 获取状态列表
      let vm = this;
      let params = {};
      params.type = 1;
      vm.$post("/app/help/statusList", params, { loading: true }).then(res => {
        console.log("statusList", res);
        vm.selectList = res;
        vm.status = vm.selectList[0].key;
        vm.getRecordList();
      });
    },
    getRecordList() {
      // 获取状态列表
      let vm = this;
      let params = {};
      params.start_date = vm.startDate;
      params.end_date = vm.endDate;
      params.type = vm.type;
      params.status = vm.status;
      params.page = vm.page;
      vm.getListFlag = false;
      vm.$post("/app/recharge/inoutrecord", params, {
        loading: true
      }).then(res => {
        console.log("inoutrecord", res);
        vm.getListFlag = true;
        vm.listData = res.result;
        vm.totalPage = res.num;
        vm.totalExpenditure = res.count;
        vm.totalIncome = res.count2;
      });
    },
    returnFun() {
      // 返回
      let vm = this;
      vm.detailFlag = false;
      vm.detail = {};
    },
    nextPage(data) {
      //跳页
      let vm = this;
      vm.page = data;
      vm.getRecordList();
    },
    _getSearch(data) {
      //搜索
      let vm = this;
      vm.startDate = data.startDate;
      vm.endDate = data.endDate;
      vm.type = data.typeVal;
      vm.status = data.statusVal;
      vm.page = 1;
      vm.getRecordList();
    },
    toDetail(data) {
      // 详情
      let vm = this;
      vm.detailFlag = true;
      vm.detail = data;
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.total-info-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .total {
    flex: 1;
    line-height: 24px;
    display: flex;
    flex-flow: wrap;
    justify-content: flex-start;
    span {
      margin-right: 10px;
    }
  }
}
.list-wrap {
  padding: 0 50px;
  .noData {
    line-height: 36px;
    text-align: center;
    font-size: 18px;
  }
  .item-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #c9c9c9;
    cursor: pointer;
    &:hover {
      background: rgba(0, 0, 0, 0.02);
    }
  }
  .item-l {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .headimg,
    .headimg img {
      width: 54px;
      height: 54px;
      border-radius: 50%;
    }
    .headimg {
      margin-right: 10px;
      background: #ddd;
    }
    h3 {
      font-size: 18px;
      font-weight: 500;
      line-height: 1;
      padding-bottom: 8px;
    }
    p {
      color: #666;
    }
  }

  .item-r {
    flex: 0 0 120px;
    text-align: right;
    h4 {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.5;
      color: #333;
      padding-bottom: 8px;
    }
  }
}
</style>
